import React, { useState, useEffect } from "react";
 // eslint-disable-next-line
import Header from "./components/header/Header.js";
 // eslint-disable-next-line
import Footer from "./components/footer/Footer.js";
import AutorizacaoGuias from "./components/autorizacaoGuias/autorizacaoGuias.js"
import ConsultaCoparticipacoes from "./components/consultaCoparticipacoes/consultaCoparticipacoes.js"
import SegundaViaBoleto from "./components/segundaViaBoleto/segundaViaBoleto.js"
import DeclaracaoImpostoDeRenda from "./components/declaracaoImpostoDeRenda/declaracaoImpostoDeRenda.js"
import DeclaracaoImpostoDeRendaCPP from "./components/declaracaoImpostoDeRenda/declaracaoImpostoDeRendaCPP.js"
import DebitoEmConta from "./components/debitoEmConta/debitoEmConta.js"
import SolicitacaoDeDocumentos from "./components/solicitacaoDeDocumentos/solicitacaoDeDocumentos.js"
import Negociacao from "./components/negociacao/negociacao.js"
import ExtratoCoparticipacoes from "./components/extratoCoparticipacoes/extratoCoparticipacoes.js"

const Main = () => {
    const [opcao, setOpcao] = useState(0)



    useEffect(() => {
        const urlOptions = {
            '#autorizacao': 1,
            '#consultacopart': 2,
            '#segundavia': 3,
            '#declaracaoir': 4,
            '#declaracaoircpp': 10,
            '#documentos': 6,
            '#extratocopart': 7
        }
        function adjustFromUrl() {
            const { hash } = window.location
            if (hash) {            
                setOpcao(urlOptions[hash])
            }
        }
        adjustFromUrl()

        // esse codigo faz uma rolagem para parte dos botoes, ao acessar a pagina
        const menuServicos = document.querySelector(".menu-servicos");
        if (menuServicos) {
            menuServicos.scrollIntoView({ behavior: "smooth" });
        }

    }, [])
 // eslint-disable-next-line
    function funcAlert() {
        alert("Esta função está temporiariamente indisponível. Para mais dúvidas favor entrar em contato.")
    }

    const onChangeOpcao = opcao => {
        setOpcao(opcao)
        window.parent.postMessage('change', window.location.origin)
    }

    const renderOpcao = () => {
        switch (opcao) {
            case 1:
                return (<AutorizacaoGuias />)
            case 2:
                return (<ConsultaCoparticipacoes />)
            case 3:
                return (<SegundaViaBoleto />)
            case 4:
                return (<DeclaracaoImpostoDeRenda />)
                //return funcAlert()
            case 5:
                return (<DebitoEmConta />)
            case 6:
                return (<SolicitacaoDeDocumentos />)
            case 7:
                return (<ExtratoCoparticipacoes />)
            case 9:
                return (<Negociacao />)
            case 10:
                return (<DeclaracaoImpostoDeRendaCPP />)
            default:
                return null
        }
    }
    return (
        <div className="content">
            {/* <Header /> */}
            <section className="full-max fill">
                <h1 className="txt-laranja mgv-2">Serviços Online</h1>

                <section className="intro txt8 txtPai lh-1">
                    <div className="txtFilho">
                        <i className="fa fa-check txt-laranja"></i> <b>Autorização de guias:</b> Solicite autorizações de terapias, exames, procedimentos cirúgicos e internações.
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Extrato de coparticipações:</b> Verifique o extrato de suas coparticipações.
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Simular coparticipação:</b> Verifique o valor de coparticipação para consultas, exames e terapias.
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>2ª via de boleto</b> Consulte e gere a segunda via de seus boletos.
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Declaração IRRF:</b> Informe de Rendimentos para fins de Imposto de Renda .
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Débito em conta:</b> Solicite que suas faturas sejam descontadas em conta.
				        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Solicitação de documentos:</b> Solicite documentos para Unimed VS.
                        <br />
                        <i className="fa fa-check txt-laranja"></i> <b>Negociação:</b> Parcelamento de boletos atrasados.
                    </div>
                    <div className="txtFilho">
                        
                    </div>
                </section>



                <div className="menu-servicos" style={{ marginTop: "20px" }} autoFocus>

                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 4 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(4)}><i className="fa fa-print icon-button"></i> Declaração IRRF</button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                    <button className={`txt8 bt-limpo sel-tela btn cpp ${opcao === 10 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(10)}><i className="fa fa-print icon-button"></i> Declaração IRRF Coparticipação</button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 1 ? "btn-active" : ""}`} onClick={() => onChangeOpcao(1)}><i className="fa fa-user-check icon-button"></i>Autorização de guias </button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>                    
                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 3 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(3)}><i className="fa fa-file-invoice-dollar icon-button"></i>2ª via de boleto</button>
                    
                </div>
                <div className="menu-servicos" style={window.innerWidth > 576 ? { marginBottom: "20px" } : { }}>
                    
                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 9 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(9)}><i className="fa fa-file-invoice-dollar icon-button"></i>Negociação</button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 2 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(2)}><i className="fa fa-search-plus icon-button"></i>Simular coparticipação</button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                    <a href="https://portaldocliente.unimedvs.com.br/debito-em-conta" target="_blank" rel="noopener noreferrer" className={`txt8 bt-limpo sel-tela btn ${opcao === 5 ? "btn-active" : ""}`}><i className="fa fa-money-check-alt icon-button"></i> Débito em conta</a>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                    <button className={`txt8 bt-limpo sel-tela btn ${opcao === 7 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(7)}><i className="fa fa-file-invoice-dollar icon-button"></i>Extrato de coparticipações</button>
                    
                </div>
                <div className="menu-servicos" style={{ marginBottom: "20px" }}>
                    <button style={window.innerWidth > 576 ? { maxWidth: "23%" } : { }} className={`txt8 bt-limpo sel-tela btn ${opcao === 6 ? "btn-active" : ""}`} id="consulta-copart" onClick={() => onChangeOpcao(6)}><i className="fa fa-folder icon-button"></i>Solicitação de documentos</button>
                    <span style={{ margin: "0 10px" }} className="txt-laranja nao-mobile">|</span>
                </div>
                {renderOpcao()}
            </section>
            {/* <Footer/> */} 
        </div>
    );
};

export default Main;
